import { useCallback, useState } from 'react'; // ADD useState here
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Logout from "../Logout/Logout";
import "./Navbar.css";
import config from "../../config";
import useAuth from "../../Auth/useAuth";
import { FaSearch } from "react-icons/fa";
import "../../Pages/HomePage/HomePage.css";
import Notifications from "../Notifications/Notifications";
import { FaComments, FaUserCog } from "react-icons/fa";

axios.defaults.baseURL = config.BASE_URL;

const Navbar = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const {
    userProfile,
    setTripIDState,
    setReviseBillState,
    setActiveModule,
    totalUnreadCount,
    // Remove searchValue and setSearchValue from context
  } = useAuth();

  // ADD: Use local state instead of context state
  const [searchValue, setSearchValue] = useState("");

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

    // Modal handler functions
  const showModal = (title, message, type = 'info') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  const handleSearchChange = useCallback((e) => {
    setSearchValue(e.target.value.toUpperCase());
  }, []);

  const handleSearch = useCallback(async () => {
    // Validate user profile permissions
    if (
      (userProfile === "loadingManager" || userProfile === "unloadingManager") &&
      searchValue.startsWith("B")
    ) {
      showModal('Access Denied', 'You do not have access to this section', 'error');
      return;
    }
    if (!searchValue) {
      showModal('Validation Error', 'Please enter a valid Trip ID/Bill ID', 'error');
      return;
    }
    try {
      // Handle Trip ID search (starts with 'T')
      if (searchValue.startsWith("T")) {
        const response = await axios.get(`/api/trip/${searchValue}`, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("TripData", response.data.TripData);
        setTripIDState(response.data.TripData);
        sessionStorage.setItem("actMod", "upload");
        setActiveModule("upload");
        Navigate(`/home/${searchValue}`);
        // Clear after navigation
        setSearchValue("");
      } 
      // Handle Bill ID search (starts with 'B')
      else if (searchValue.startsWith("B")) {
        const bill_id = searchValue;
        
        const response = await axios.post(
          "/list-to-revise-bill",
          { bill_id },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Revised Bill listing: ", response.data);
        // Set the reviseBillState first
        setReviseBillState(response.data);
        
        // Set the flag to indicate this is from navbar search
        sessionStorage.setItem("reviseBillSearchProcessed", "true");
        sessionStorage.setItem("actMod", "revise-bill");
        setActiveModule("revise-bill");
        
        // Navigate to revise-bill with bill_id parameter
        Navigate(`/revise-bill?bill_id=${bill_id}`);
        
        // Clear search value after successful search
        setSearchValue("");
      } 
      else {
        showModal('Validation Error', 'Please enter a valid Trip ID/Bill ID', 'error');
      }
    } catch (error) {
      console.error("Search error:", error);
      
      if (error?.response?.data?.message) {
        showModal('Error', error.response.data.message, 'error');
      } else {
        const errorType = searchValue.startsWith("T") ? "trip" : "bill";
        showModal('Error', `Error fetching the ${errorType} data. Please try again.`, 'error');
      }
    }
  }, [searchValue, userProfile, setTripIDState, setActiveModule, setReviseBillState, Navigate]);

  const handleKeyPress = useCallback((event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  }, [handleSearch]);

  const getRouteName = () => {
    const path = location.pathname;

    if (path === "/home") {
      return "Upload Trip Details";
    }
    if (path.startsWith("/home/") && path !== "/home") {
      return "Upload Trip Details";
    }
    if (path === "/today-list") {
      return "Today's List";
    } else if (path === "/freight") {
      return "Freight";
    } else if (path === "/vehicle") {
      return "Vehicle";
    } else if (path === "/vendor") {
      return "Vendor";
    } else if (path === "/reports") {
      return "Reports";
    } else if (path === "/generate-bill") {
      return "Billing";
    } else if (path === "/transactions") {
      return "Transactions";
    } else if (path === "/business") {
      return "Business";
    } else if (path === "/revise-bill") {
      return "Revise Bill";
    } else if (path === "/chat") {
      return "Chat";
    } else if (path === "/profile") {
      return "Profile";
    } else if (path === "/list-users") {
      return "Manage Users";
    } else if (path === '/order-book') {
      return 'Order Book'
    } else if (path === '/task') {
      return 'Task'
    } else if (path === '/approval') {
      return 'Approval'
    }
    return "";
  };

  const handleManageUsersClick = () => {
    if (userProfile === "admin") {
      Navigate("/list-users");
    }
  };

  return (
    <nav className="navbar">
      {/* <div className="navbar-left">
        <img src={logo} alt="Logo" className="logo" />
        <>
          <FaUserCircle className="profile-icon" />
          <div
            className="profile-container"
            onClick={() => Navigate("/profile")}
          >
            <div className="profile-info">
              <span className="profile-name">
                {username}, {userProfile.toUpperCase()}
              </span>
            </div>
          </div>
        </>
      </div> */}

      <div className="route-name-container">
        <div className="route-name">{getRouteName()}</div>
      </div>

      <div className="nav-buttons-right">
        <div className="search-bar-container">
          <FaSearch className="search-icon" onClick={handleSearch} />
          <input
            className="search-bar"
            key="navbar-search-stable"
            type="text"
            placeholder="Search Trip/Bill ID"
            value={searchValue}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            autoComplete="off"
          />
        </div>
        {userProfile === "admin" && (
          <FaUserCog
            className="manage-users-icon"
            onClick={handleManageUsersClick}
            title="Manage Users"
          />
        )}

        {/* <FaComments
          className="chat-icon"
          onClick={() => {
            sessionStorage.setItem("actMod", "");
            setActiveModule("");
            Navigate("/chat");
          }}
        /> */}
        <div className="chat-icon-wrapper">
          <FaComments
            className="chat-icon"
            onClick={() => {
              sessionStorage.setItem("actMod", "");
              setActiveModule("");
              Navigate("/chat");
            }}
          />
          {totalUnreadCount > 0 && (
            <span className="chat-notification-badge">
              {totalUnreadCount > 99 ? '99+' : totalUnreadCount}
            </span>
          )}
        </div>
        {userProfile !== "loadingManager" && <Notifications />}
        <Logout />
      </div>
    </nav>
  );
};

export default Navbar;